export enum IntegrationExactStatusEnum {
  UNKNOWN = "unknown",
  PENDING_AUTHORISATION = "pending-authorisation",
  ACTIVE = "active",
  EXPIRED = "expired",
  DISABLED = "disabled",
}
